if (!customElements.get(`product-info`)) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.isEnabledStickyContent = this.dataset.enabledStickyContent === 'true';
      this.shouldUpdateDocumentTitle = this.dataset.updateDocumentTitle === 'true';
      if (this.shouldUpdateDocumentTitle) {
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, (event) => {
          this.updateDocumentTitle(event.detail && event.detail.currentVariant);
        });
      }
      if (this.isEnabledStickyContent) {
        this.setStickyHeight();
        window.addEventListener('resize', this.setStickyHeight.bind(this));
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, () => {
          this.setStickyHeight();
        });
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", (event) => {
            if (!event.target.classList.contains('section-product-details') && !event.target.classList.contains('section-main-product')) return;
            this.setStickyHeight();
          });

          document.addEventListener("shopify:section:reorder", () => {
            this.setStickyHeight();
          });
        }
      }
    }

    updateDocumentTitle(variant) {
      const dataEl = document.getElementById('product-meta-title-data');
      if (!dataEl || !variant) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      const rawOptions = Array.isArray(variant.options) && variant.options.length
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      const options = rawOptions.filter((value) => value && value !== 'Default Title');
      let variantPart = '';
      if (options.length >= 2) {
        variantPart = `${options[0]} x ${options[1]}`;
      } else if (options.length === 1) {
        variantPart = options[0];
      }

      const left = [data.productTitle, variantPart].filter(Boolean).join(' ');
      const middle = [data.grade, data.animal].filter(Boolean).join(' ');
      const title = [left, middle, data.shop].filter(Boolean).join(' | ');

      document.title = title;
      document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach((el) => {
        el.setAttribute('content', title);
      });
    }

    setStickyHeight() {
      const mediaEl = this.querySelector(`.product-template__media-wrapper[data-section-id="${this.sectionId}"]`);
      const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`);
      if (!contentSideEle) return;

      if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
        requestAnimationFrame(() => {
          let totalHeightMediaSide = 0;
          document.querySelectorAll(`.product-template__media-wrapper[data-section-id="${this.sectionId}"]`).forEach((elem) => {
            totalHeightMediaSide += elem.getBoundingClientRect().height;
          });

          const contentSideContainerEle = contentSideEle.querySelector(`.product-template__content__container`);
          const contentHeight = contentSideEle.getBoundingClientRect().height;

          if (contentHeight > totalHeightMediaSide) {
            if (mediaEl) {
              mediaEl.classList.add('md:sticky', 'sticky-main-product-top');
            }
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.remove('md:sticky');
            }
            contentSideEle.style.minHeight = 'auto';
          } else {
            if (mediaEl) {
              mediaEl.classList.remove('md:sticky', 'sticky-main-product-top');
            }
            contentSideEle.style.minHeight = `${totalHeightMediaSide}px`;
            if (contentSideContainerEle) {
              contentSideContainerEle.classList.add('md:sticky');
            }
          }
        });
      } else {
        contentSideEle.style.minHeight = 'auto';
        if (mediaEl) {
          mediaEl.classList.remove('md:sticky', 'sticky-main-product-top');
        }
      }
    }
  }

  customElements.define(`product-info`, ProductInfo);
}
